import { useToast } from "@common/hooks/use-toast"

const useCustomToast = () => {
  const { toast } = useToast()

  return (title: string, description: string, type: "success" | "error") => {
    toast({
      title,
      description,
      variant: type === "error" ? "destructive" : "success",
    })
  }
}

export default useCustomToast
